import {DataSource} from "../../../../constants/DataSource/DataSource";
import React, {FC, useEffect, useRef, useState} from "react";
import DataSources from "components/DataSources/DataSources";
import plusIcon from "../../../../assets/images/plus-icon.svg";
import Tabs from "../../../Tabs2";
import trashIcon from "../../../../assets/images/trashBin.svg";
import ReactInputMask from "react-input-mask";
import TableCalendar from "../../../TableCalendar/TableCalendar";
import {SupplierEmployee, WorkSchedule} from "../../../../constants/Supplier/SupplierEmployee";
import {t} from "i18next";
import Input from "../../../commons/Input/Input";
import {DataSourceStatus} from "../../../../constants/DataSource/DataSourceStatus";
import Validations from "../Validations";
import PhoneInput from "../../../commons/Input/PhoneInput";
import Employee from "./Employee";


interface DataSourcesProps {
    data: SupplierEmployee[],
    updateDataHandler: (data: SupplierEmployee[]) => void
}

const { List, Body, Tab, Panel }: any = Tabs;

const Employees: FC<DataSourcesProps> = ({data, updateDataHandler}) => {


    const [componentUpdateTrigger, setComponentUpdateTrigger] = useState<boolean>(false)

    const initialWorkScheduleValue: WorkSchedule = {
        monday: [8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18],
        tuesday: [8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18],
        wednesday: [
            8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
        ],
        thursday: [
            8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
        ],
        friday: [8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18],
        saturday: [
            8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
        ],
        sunday: [8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18],
    }

    const initialValue: SupplierEmployee = {
        name: '',
        email: '',
        phone: '',
        workSchedule: initialWorkScheduleValue
    }

    function toggleComponentUpdateTrigger() {
        setComponentUpdateTrigger(!componentUpdateTrigger)
    }

    function addNewEmployeeHandler() {
        data.push(initialValue)
        updateDataHandler(data)
        toggleComponentUpdateTrigger()
    }

    function deleteEmployeeHandler(index: number) {
        console.log('Before delete', index, data)
        data = data.filter((v, i) => i !== index)
        console.log('After delete', data)
        updateDataHandler(data)
        toggleComponentUpdateTrigger()
    }

    function updateDataItemHandler(index: number, payload: SupplierEmployee|null) {
        if (data && !payload) {
            data.forEach((v, i) => {
                if (i === index) {
                    data.splice(i, 1);
                    console.log('rm empl row')
                }
            })
        } else if (payload) {
            let isUpdated = false
            for (let i in data) {
                if (parseInt(i) === index) {
                    data[i] = payload
                    isUpdated = true
                    console.log('update empl row')
                    break
                }
            }
            if (!isUpdated) {
                console.log('add new empl row')
                data.push(payload)
            }
        }

        console.log('Employees. updateDataHandler: ', data)
        updateDataHandler(data)
    }

    return (
        <>
            <div data-update-component={componentUpdateTrigger} className="text-w-sm text-gray-600 text-left font-medium mb-4 mt-8 flex items-center">
                <div className="pr-[40px] text-[#1E293B] font-bold text-l">
                    Контакты
                </div>
                <button
                    type="button"
                    className={'focus:outline-none'}
                    onClick={addNewEmployeeHandler}
                >
                    <img src={plusIcon} />
                </button>
            </div>
            {data.length > 0 &&
                <Tabs>
                    <List className={'contact-list'}>
                        {data.map((employee, index) => (
                            <Tab
                                key={index}
                                to={`#contact-${index}`}
                                className={'contact-person'}
                                containerClassName={`py-1`}
                            >
                                {employee.name || `Контакт ${index + 1}`}
                            </Tab>
                        ))}
                    </List>

                    <Body>
                        {data.map((employee, index) => (
                            <Panel
                                key={index}
                                name={`contact-${index}`}
                                className={'contact-list-panel'}
                            >

                                <div className="delete-contacts flex justify-end">
                                    <button
                                        type={`button`}
                                        className="flex-row items-center text-red-600 text-left font-medium mb-1 flex border-[1px] px-[15px] text-[13px] py-[2px] rounded mt-2 active:outline-none"
                                        data-index={index}
                                        onClick={() => deleteEmployeeHandler(index)}
                                    >
                                        <img src={trashIcon} className="h-[14px] mr-2" />
                                        <div>Удалить контакт</div>
                                    </button>
                                </div>

                                <Employee
                                    index={index}
                                    data={employee}
                                    updateDataHandler={updateDataItemHandler}
                                    initialWorkScheduleValue={initialWorkScheduleValue}
                                ></Employee>
                            </Panel>
                        ))}
                    </Body>
                </Tabs>
            }
        </>
    )
}

export default Employees
